module.exports = __webpack_public_path__ + "components/feature-news-posts/static/placeholder-3d442276e5b1b06809ee08b60b8bf2eb.png";